import type { SonaroCRMDto } from './models';
import { RestService } from '@abp/ng.core';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class SonaroCRMSettingsService {
  apiName = 'Default';
  

  getSonaroCRMInformation = () =>
    this.restService.request<any, SonaroCRMDto>({
      method: 'GET',
      url: '/api/app/sonaro-cRMSettings/sonaro-cRMInformation',
    },
    { apiName: this.apiName });
  

  setSonaroCRMInformation = (input: SonaroCRMDto) =>
    this.restService.request<any, void>({
      method: 'POST',
      url: '/api/app/sonaro-cRMSettings/set-sonaro-cRMInformation',
      body: input,
    },
    { apiName: this.apiName });

  constructor(private restService: RestService) {}
}
